// extracted by mini-css-extract-plugin
export default {"capsuleContainer":"capsuleContainer___iVXLz","capsuleLabel":"capsuleLabel___Ee3_C","capsuleValue":"capsuleValue____G9ZH"};